{
  "gpt-3.5-turbo-0125": {
    "modelName": "gpt-3.5-turbo-0125",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.5,
            "outputPricePerMillion": 1.5
          }
        }
      }
    ]
  },
  "gpt-3.5-turbo-1106": {
    "modelName": "gpt-3.5-turbo-1106",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.5,
            "outputPricePerMillion": 1.5
          }
        }
      }
    ]
  },
  "gpt-3.5-turbo": {
    "modelName": "gpt-3.5-turbo",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.5,
            "outputPricePerMillion": 1.5
          }
        }
      }
    ]
  },
  "gpt-4-0125-preview": {
    "modelName": "gpt-4-0125-preview",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 30,
            "outputPricePerMillion": 60
          }
        }
      }
    ]
  },
  "gpt-4-0613": {
    "modelName": "gpt-4-0613",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 30,
            "outputPricePerMillion": 60
          }
        }
      }
    ]
  },
  "gpt-4-1106-preview": {
    "modelName": "gpt-4-1106-preview",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 30,
            "outputPricePerMillion": 60
          }
        }
      }
    ]
  },
  "gpt-4-turbo-2024-04-09": {
    "modelName": "gpt-4-turbo-2024-04-09",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 10,
            "outputPricePerMillion": 30
          }
        }
      }
    ]
  },
  "gpt-4-turbo-preview": {
    "modelName": "gpt-4-turbo-preview",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 10,
            "outputPricePerMillion": 30
          }
        }
      }
    ]
  },
  "gpt-4-turbo": {
    "modelName": "gpt-4-turbo",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 10,
            "outputPricePerMillion": 30
          }
        }
      }
    ]
  },
  "gpt-4": {
    "modelName": "gpt-4",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 30,
            "outputPricePerMillion": 60
          }
        }
      }
    ]
  },
  "gpt-4o-2024-05-13": {
    "modelName": "gpt-4o-2024-05-13",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 20
          }
        }
      }
    ]
  },
  "gpt-4o-2024-08-06": {
    "modelName": "gpt-4o-2024-08-06",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 2.5,
            "outputPricePerMillion": 10
          }
        }
      }
    ]
  },
  "gpt-4o-mini-2024-07-18": {
    "modelName": "gpt-4o-mini-2024-07-18",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.6,
            "outputPricePerMillion": 2.4
          }
        }
      }
    ]
  },
  "gpt-4o-mini": {
    "modelName": "gpt-4o-mini",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.6,
            "outputPricePerMillion": 2.4
          }
        }
      }
    ]
  },
  "gpt-4o": {
    "modelName": "gpt-4o",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 20
          }
        }
      }
    ]
  },
  "chatgpt-4o-latest": {
    "modelName": "chatgpt-4o-latest",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 15
          }
        }
      }
    ]
  },
  "o1-2024-12-17": {
    "modelName": "o1-2024-12-17",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 15,
            "outputPricePerMillion": 60
          }
        }
      }
    ]
  },
  "o1": {
    "modelName": "o1",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 15,
            "outputPricePerMillion": 60
          }
        }
      }
    ]
  },
  "o3-mini-2025-01-31": {
    "modelName": "o3-mini-2025-01-31",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.1,
            "outputPricePerMillion": 4.4
          }
        }
      }
    ]
  },
  "o3-mini": {
    "modelName": "o3-mini",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.1,
            "outputPricePerMillion": 4.4
          }
        }
      }
    ]
  },
  "o3-2025-04-16": {
    "modelName": "o3-2025-04-16",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 10.0,
            "outputPricePerMillion": 40.0
          }
        }
      }
    ]
  },
  "o3": {
    "modelName": "o3",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 10.0,
            "outputPricePerMillion": 40.0
          }
        }
      }
    ]
  },
  "o4-mini-2025-04-16": {
    "modelName": "o4-mini-2025-04-16",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.1,
            "outputPricePerMillion": 4.4
          }
        }
      }
    ]
  },
  "o4-mini": {
    "modelName": "o4-mini",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.1,
            "outputPricePerMillion": 4.4
          }
        }
      }
    ]
  },
  "gpt-4.1": {
    "modelName": "gpt-4.1",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 2.0,
            "outputPricePerMillion": 8.0
          }
        }
      }
    ]
  },
  "gpt-4.1-mini": {
    "modelName": "gpt-4.1-mini",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.4,
            "outputPricePerMillion": 1.6
          }
        }
      }
    ]
  },
  "gpt-4.1-nano": {
    "modelName": "gpt-4.1-nano",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.1,
            "outputPricePerMillion": 0.4
          }
        }
      }
    ]
  },
  "gpt-5": {
    "modelName": "gpt-5",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.25,
            "outputPricePerMillion": 10.0
          }
        }
      }
    ]
  },
  "gpt-5-mini": {
    "modelName": "gpt-5-mini",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.25,
            "outputPricePerMillion": 2.0
          }
        }
      }
    ]
  },
  "gpt-5-nano": {
    "modelName": "gpt-5-nano",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.05,
            "outputPricePerMillion": 0.4
          }
        }
      }
    ]
  },
  "gpt-5-chat-latest": {
    "modelName": "gpt-5-chat-latest",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.25,
            "outputPricePerMillion": 10.0
          }
        }
      }
    ]
  },
  "gpt-5.1": {
    "modelName": "gpt-5.1",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.5,
            "outputPricePerMillion": 12.0
          }
        }
      }
    ]
  },
  "gpt-5.2": {
    "modelName": "gpt-5.2",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.75,
            "outputPricePerMillion": 14.0
          }
        }
      }
    ]
  },
  "gpt-5.2-codex": {
    "modelName": "gpt-5.2-codex",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.75,
            "outputPricePerMillion": 14.0
          }
        }
      }
    ]
  },
  "gpt-5.2-chat-latest": {
    "modelName": "gpt-5.2-chat-latest",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 1.75,
            "outputPricePerMillion": 14.0
          }
        }
      }
    ]
  },
  "gpt-5.2-pro": {
    "modelName": "gpt-5.2-pro",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 21.0,
            "outputPricePerMillion": 168.0
          }
        }
      }
    ]
  },
  "gpt-5.3-codex": {
    "modelName": "gpt-5.3-codex",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 2.1,
            "outputPricePerMillion": 16.8
          }
        }
      }
    ]
  },
  "gpt-5.4": {
    "modelName": "gpt-5.4",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 2.5,
            "outputPricePerMillion": 15.0
          }
        }
      }
    ]
  },
  "gpt-5.4-mini": {
    "modelName": "gpt-5.4-mini",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.75,
            "outputPricePerMillion": 4.5
          }
        }
      }
    ]
  },
  "gpt-5.4-pro": {
    "modelName": "gpt-5.4-pro",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 30.0,
            "outputPricePerMillion": 180.0
          }
        }
      }
    ]
  },
  "gpt-5.5": {
    "modelName": "gpt-5.5",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": 272000,
        "prices": {
          "base": {
            "inputPricePerMillion": 5.0,
            "outputPricePerMillion": 30.0
          }
        }
      },
      {
        "minTokens": 272000,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 10.0,
            "outputPricePerMillion": 45.0
          }
        }
      }
    ]
  },
  "gpt-4o-search-preview": {
    "modelName": "gpt-4o-search-preview",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 20
          }
        }
      }
    ]
  },
  "gpt-4o-search-preview-2025-03-11": {
    "modelName": "gpt-4o-search-preview-2025-03-11",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 20
          }
        }
      }
    ]
  },
  "gpt-4o-mini-search-preview": {
    "modelName": "gpt-4o-mini-search-preview",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.6,
            "outputPricePerMillion": 2.4
          }
        }
      }
    ]
  },
  "gpt-5-search-api": {
    "modelName": "gpt-5-search-api",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 5,
            "outputPricePerMillion": 20
          }
        }
      }
    ]
  },
  "gpt-4o-mini-search-preview-2025-03-11": {
    "modelName": "gpt-4o-mini-search-preview-2025-03-11",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.6,
            "outputPricePerMillion": 2.4
          }
        }
      }
    ]
  },
  "gpt-5.5-pro": {
    "modelName": "gpt-5.5-pro",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 30.0,
            "outputPricePerMillion": 180.0
          }
        }
      }
    ]
  },
  "gpt-5.4-nano": {
    "modelName": "gpt-5.4-nano",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 0.2,
            "outputPricePerMillion": 1.25
          }
        }
      }
    ]
  },
  "gpt-5-pro": {
    "modelName": "gpt-5-pro",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 15.0,
            "outputPricePerMillion": 120.0
          }
        }
      }
    ]
  },
  "o3-pro": {
    "modelName": "o3-pro",
    "currency": "USD",
    "tokenRanges": [
      {
        "minTokens": 0,
        "maxTokens": null,
        "prices": {
          "base": {
            "inputPricePerMillion": 20.0,
            "outputPricePerMillion": 80.0
          }
        }
      }
    ]
  }
}
